import Template from "./template";

export default {
  path: "profile",
  element: <Template />,
  loader: async () => {
    return {};
  },
};
